// extracted by mini-css-extract-plugin
module.exports = {"root":"IMGqTc","facebook":"_306MRG","disabled":"_16Fyc0","facebookCircle":"eIYQn2","google":"iq7Y2H","apple":"_38lOE9","whatsApp":"_2KwKfU","shine-lines":"_1YbRvf"};